import { CountryConfigImpl } from "../data/CountryConfigImpl";
import { ICountryConfigRepository } from "../domain/repositories/ICountryConfigRepository";
import { CountryConfigUseCase } from "../domain/useCases/CountryConfigUseCase";
import { CountryConfigViewModel } from "../presentation/viewModel/CountryConfigViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class CountryConfigInjection extends InjectionModule {
  private static readonly countryConfigRepositoryToken =
    Symbol("ICountryConfigRepo");
  private static readonly countryConfigUseCaseToken = Symbol(
    "CountryConfigUseCase",
  );
  private static readonly countryConfigViewModelToken = Symbol(
    "CountryConfigViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.countryConfigRepositoryToken,
      useClass: CountryConfigImpl,
    },
    {
      scope: "otherRepo",
      token: this.countryConfigUseCaseToken,
      useClass: CountryConfigUseCase,
    },
    {
      scope: "viewModel",
      token: this.countryConfigViewModelToken,
      useClass: CountryConfigViewModel,
    },
  ];

  static getCountryConfigRepo(): ICountryConfigRepository {
    return this.resolve(this.countryConfigRepositoryToken);
  }

  static getCountryConfigUseCase(): CountryConfigUseCase {
    return this.resolve(this.countryConfigUseCaseToken);
  }
}
